<template>
  <div>
    <van-popup
      v-model="visible"
      :closeable="closeable"
      position="right"
      :style="{ height: '100%', width: '85%' }"
      @closed="visible = false"
    >
      <h2 class="hd-title">{{ title }}</h2>
      <div class="search-form">
        <dataForm
          :items="formOption.content"
          :submitButton="false"
          ref="dataForm"
          isVerify
          @submit="onSubmit"
        ></dataForm>
      </div>
      <div class="popup-footer-buttons">
        <van-button type="default" @click="onReset">重置</van-button>
        <van-button type="info" @click="onSubmit">确认</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
// import globalApi from "@/api/global.js";
import dataForm from "@/components/base/form/dataForm"
import buildingManagementApi from "@/api/buildingManagement.js"
import { Button, Popup } from "vant"
import moment from "moment"

export default {
  name: "queryPopup",
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    dataForm,
  },
  props: {
    closeable: {
      type: Boolean,
      default: true,
    },
    defaultSearchData: { type: Object, default: () => {} },
    formData: {
      type: Object,
      default: () => {},
    },
    submit: Function,
    title: {
      type: String,
      default: "查询",
    },
  },
  data() {
    return {
      visible: false,
      formOption: {
        content: [
          {
            title: "日期",
            field: "date",
            itemRender: {
              name: "a-calendar",
              props: {
                titleWidth: "50px",
                // minDate: new Date(1900, 0, 1),
                // maxDate: new Date(2099, 12, 31),
              },
            },
          },
          {
            title: "楼栋",
            field: "BuildingCode",
            itemRender: {
              name: "a-select",
              props: {
                api: buildingManagementApi.QueryMeetingRoomBuildings,
                param: {},
                dataField: "Data",
                valueField: "BuildingCode",
                labelField: "Name",
                titleWidth: "50px",
              },
              on: {
                change() {},
              },
            },
          },
          {
            title: "展馆",
            field: "MeetingRoomTypeId",
            itemRender: {
              name: "a-select",
              props: {
                api: buildingManagementApi.QueryMeetingRoomTypes,
                param: {},
                dataField: "Data",
                valueField: "TypeId",
                labelField: "Name",
                titleWidth: "50px",
              },
              on: {
                change() {},
              },
            },
          },
        ],
      },
    }
  },
  created() {},
  mounted() {
    let that = this
    this.visible = true
    let { formData } = that
    that.$nextTick(() => {
      that.$refs.dataForm.setData({
        ...formData,
      })
    })
  },
  methods: {
    onReset() {
      this.$refs.dataForm.restore()
      this.$refs.dataForm.setValue(this.defaultSearchData)
    },
    async onSubmit() {
      const values = await this.$refs.dataForm.validateFields()
      await this.$emit("submit", values)
      this.visible = false
    },
    getAreaOrTableSelectData(relatedId, code) {
      return new Promise((resolve, reject) => {
        globalApi
          .selectData({
            code: code,
            relatedId: relatedId,
          })
          .then((res) => {
            resolve(res.data)
          })
          .catch(() => {
            reject()
          })
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.van-field__label {
  width: 60px;
}
.hd-title {
  padding-top: 16px;
  font-weight: normal;
  text-align: center;
  font-size: 18px;
  padding-bottom: 20px;
}
.second-title {
  margin: 10px 5px;
}
.search-form {
  height: calc(100vh - 105px);
  overflow: auto;
  padding-bottom: 100px;
}
.search-actions {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0;
}
</style>
